import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.paleGrey,
  fontColor: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default promoBanner;